import axios from '../axios';
import { BASE_URL } from '../Utils';

const ROUTES_BASE_URL = `${BASE_URL}/routes`;
const STOPS_URL = `${BASE_URL}/stops`;

export function getTodayRoute(filterDate) {
  return axios({
    url: `${ROUTES_BASE_URL}/my-routes?date=${filterDate}`,
    method: 'get',
  });
}

// CLAUDE-SYNC: v1.7.12 (2026-09-02) — optional lat/lng, captured at
// Arrived/Delivered transitions (mileage-audit foundation, per Tanaya).
// Best-effort: omitted entirely when the caller doesn't have coordinates.
export function updateRouteStopStatus(stopId, status, lat, lng) {
  return axios({
    url: `${STOPS_URL}/${stopId}/status`,
    method: 'put',
    data: {
      status,
      ...(lat != null && lng != null && { lat, lng }),
    },
  });
}

export function uploadDriverStopPhoto(stopId, photoType, photoFile) {
  const formData = new FormData();
  formData.append('photoType', photoType);
  formData.append('photo', photoFile);
  return axios({
    url: `${STOPS_URL}/${stopId}/photo`,
    method: 'put',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}